<template>
  <div class="cancelar">
    <h1>Cancelamento de Preenchimento</h1>
    <p>Você optou por cancelar o preenchimento do formulário de admissão.</p>
    <p><a href="javascript:void(0)" @click="$router.go(-1)">Clique aqui</a> para voltar ao formulário.</p>
  </div>
</template>

<script>
export default {
  name: 'cancelar'
}
</script>
